(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/flag.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/flag.js');
"use strict";

const ReactFlag = svs.lb_ui.ReactFlag;
const Flag = _ref => {
  let country = _ref.country;
  if (country && country.isoCode) {
    return React.createElement(ReactFlag, {
      className: "tt-icon-flag add-favorite-icon-flag",
      iso: country.isoCode,
      title: country.name
    });
  }
  return React.createElement("span", {
    className: "tt-icon-flag add-favorite-icon-flag add-favorite-icon-flag-empty",
    title: country ? country.name : ''
  });
};
setGlobal('svs.tt.components.Flag', Flag);

 })(window);